import React, {
    useEffect,
    useState,
} from 'react'
import {
    useHistory,
    useParams,
} from 'react-router'
import { database } from '../../components/shared/database'
import { v4 as uuid } from 'uuid'
import OverlayLoader from '../../components/shared/overlay-loader'

const RecipeForm = () => {
    const { recipeUid } = useParams()
    const history = useHistory()

    const [recipe, setRecipe] = useState({
        uid: '',
        name: '',
        procedure: '',
        ingredients: {},
    })
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (recipeUid) {
            setIsLoading(true)

            database('recipes')
                .doc(recipeUid)
                .get()
                .then(snapshot => setRecipe(snapshot.data()))
                .then(() => setIsLoading(false))
        }
    }, [recipeUid])

    const setRecipeValue = (key, value) => {
        setRecipe(oldRecipe => ({
            ...oldRecipe,
            [key]: value,
        }))
    }

    const addIngredient = () => {
        const newUid = uuid()

        setRecipe(oldRecipe => ({
            ...oldRecipe,
            ingredients: {
                ...oldRecipe.ingredients,
                [newUid]: {
                    uid: newUid,
                    size: '',
                    name: '',
                }
            }
        }))
    }

    const removeIngredient = ingredientUid => {
        setRecipe(oldRecipe => {
            const ingredients = { ...oldRecipe.ingredients }
            delete ingredients[ingredientUid]

            return {
                ...oldRecipe,
                ingredients: ingredients,
            }
        })
    }

    const setIngredientValue = (ingredientUid, key, value) => {
        setRecipe(oldRecipe => ({
            ...oldRecipe,
            ingredients: {
                ...oldRecipe.ingredients,
                [ingredientUid]: {
                    ...oldRecipe.ingredients[ingredientUid],
                    [key]: value,
                }
            }
        }))
    }

    const saveRecipe = () => {
        const uid = recipeUid || uuid()

        setIsLoading(true)

        return database('recipes')
            .doc(uid)
            .set({
                ...recipe,
                uid: uid,
            })
            .then(() => setIsLoading(false))
            .then(() => history.push('/recipes'))
    }

    return (
        <div className="d-flex flex-column container mt-5">
            <div className="form-group">
                <label htmlFor="recipe-name">
                    Název receptu
                </label>
                <input
                    type="text"
                    className="form-control"
                    id="recipe-name"
                    value={recipe.name || ''}
                    onChange={event => setRecipeValue('name', event.target.value)}
                />
            </div>

            <div className="mt-2">
                {Object.entries(recipe.ingredients || {})
                    .map(([uid, ingredient]) => (
                        <div className="d-flex flex-row align-items-center" key={uid}>
                            <div>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={ingredient.size || ''}
                                    placeholder="Množství"
                                    onChange={event => setIngredientValue(uid, 'size', event.target.value)}
                                />
                            </div>
                            <div>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={ingredient.name || ''}
                                    placeholder="Název"
                                    onChange={event => setIngredientValue(uid, 'name', event.target.value)}
                                />
                            </div>
                            <div className="ml-2" onClick={() => removeIngredient(uid)}>
                                <i className="fas fa-trash"/>
                            </div>
                        </div>
                    ))}


                <div
                    className="btn btn-outline-info"
                    onClick={() => addIngredient()}
                >
                    + Přidat ingredienci
                </div>
            </div>


            <div className="form-group mt-2">
                <label htmlFor="recipe-procedure">
                    Postup
                </label>
                <textarea
                    className="form-control"
                    id="recipe-procedure"
                    value={recipe.procedure || ''}
                    onChange={event => setRecipeValue('procedure', event.target.value)}
                />
            </div>

            <div>
                <div
                    className="btn btn-success"
                    onClick={() => saveRecipe()}
                >
                    Uložit
                </div>
            </div>

            {isLoading && <OverlayLoader />}
        </div>
    )
}

export default RecipeForm
